import * as React from "react";
import { Button, Grid, IconButton } from "@mui/material";
import { useSidebar } from "../context/SidebarContext";
import { ToolBarWrapper } from "../styles/LayoutStyles";
import { IconMenuDeep } from "@tabler/icons-react";
import useMediaQuery from "@/shared/hooks/use-media-query";
import ShortCut from "./ShortCut";
import AccountSection from "./Account";

const ToolBar: React.FC = () => {
  const { toggleSideBar } = useSidebar();
  const { isMobile } = useMediaQuery();
  return (
    <ToolBarWrapper container alignItems="center">
      {isMobile && (
        <Grid item xs="auto">
          <IconButton onClick={toggleSideBar}>
            <IconMenuDeep />
          </IconButton>
        </Grid>
      )}

      <Grid item xs="auto" id="tool-bar"></Grid>
      <Grid flex={1} />
      <Grid item xs="auto">
        <ShortCut />
      </Grid>
      <Grid item xs="auto">
        <AccountSection />
      </Grid>
    </ToolBarWrapper>
  );
};

export default ToolBar;
